export const fieldNameToProperty = (fieldName: string): string => fieldName.replace('company.', '')

export const mapCompanyToRequest = (formData: Record<string, any>): Record<string, any> =>
  Object.fromEntries(
    Object.entries(formData).map(([fieldName, value]) => [fieldNameToProperty(fieldName), value])
  )
